import axios from "axios";
import * as Sentry from "@sentry/nextjs";

const secretApiAxios = axios.create({
  baseURL: process.env.SECRET_APP_API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
		"Authorization": `Bearer ${process.env.SECRET_APP_API_TOKEN}`
  },
});

secretApiAxios.interceptors.response.use(
  response => {
    // Qualquer código de status 2xx faz com que esta função seja acionada
    return response;
  },
  error => {
    error.message = '[STRAPI] - ' + error.message;
    Sentry.captureException(error);
    
    return Promise.reject(error);
  }
);

export default secretApiAxios